import {combineReducers} from '@reduxjs/toolkit';

import {assignedUsersReducer} from './modules/role-profile/assigned-users';
import {profileHistoryReducer} from './modules/role-profile/profile-history';

export const adminRightsReducer = combineReducers({
    profileHistory: profileHistoryReducer,
    assignedUsers: assignedUsersReducer,
});
